var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-selected': _vm.isOutcomeSelected({
        outright: _vm.outright,
        market: _vm.market,
        outcome: _vm.outcome,
    }) && _vm.details == false,
    'is-blocked': (_vm.outright.status == 'active' && _vm.outcome.status == 'block') && _vm.details == false}},[(_vm.details == false)?[_c('div',{staticClass:"odd-head"},[_vm._v(_vm._s(_vm._f("formatModifierName")(_vm.outcome.name,null, _vm.market.specifiers)))]),_c('div',{staticClass:"odd-number",on:{"click":function($event){$event.stopPropagation();return _vm.selectOutrightOutcome({
                outright: _vm.outright,
                market: _vm.market,
                outcome: _vm.outcome,
            })}}},[_c('div',{staticClass:"odd-change",class:{'odd-up' : _vm.up, 'odd-down': _vm.down}}),_vm._v("\n                "+_vm._s(_vm._f("formatOdd")(_vm.outcome.value))+"\n            ")])]:[_c('div',{staticClass:"sgame-odd-header"},[_vm._v("\n        "+_vm._s(_vm._f("formatModifierName")(_vm.outcome.name,null, _vm.market.specifiers))+"\n        ")]),_c('div',{staticClass:"sgame-odd-value",class:{'is-selected': _vm.isOutcomeSelected({
            outright: _vm.outright,
            market: _vm.market,
            outcome: _vm.outcome,
        }), 'is-blocked': (_vm.outright.status == 'active' && _vm.outcome.status == 'block')},on:{"click":function($event){return _vm.selectOutrightOutcome({
            outright: _vm.outright,
            market: _vm.market,
            outcome: _vm.outcome,
        })}}},[_c('div',{staticClass:"odd-change",class:{'odd-up' : _vm.up, 'odd-down': _vm.down}}),_vm._v("\n            "+_vm._s(_vm._f("formatOdd")(_vm.outcome.value))+"\n        ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }